import React, { useState } from "react";
import PreviewIcon from "@mui/icons-material/Preview";
import EditIcon from "@mui/icons-material/Edit";
import { Button, IconButton, Stack, TextField } from "@mui/material";
import MarkdownBlock from "components/react-lib/markdown-code/MarkdownBlock";
import { useTheme } from "@emotion/react";
import SectionContainer from "./SectionContainer";
import { extractLinksAndReplace } from "../google-docs/googleDocs";

export default function SimpleMarkdownEditor({
  value,
  setValue,
  onTogglePreivew = () => {},
  onBlur = () => {},
}) {
  const theme = useTheme();
  const [previewing, setPreviewing] = useState(false);

  const handleBlur = () => {
    onBlur();
  };

  const handlePreview = () => {
    onTogglePreivew();
    setPreviewing(!previewing);
  };

  const renderContent = () => {
    if (previewing) {
      return (
        <MarkdownBlock
          markdownContent={value}
          style={{
            color: theme.palette.text.main,
            paddingTop: "20px",
          }}
        />
      );
    }
    return (
      <TextField
        multiline
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onBlur={handleBlur}
        sx={{
          paddingTop: "20px",
        }}
      />
    );
  };
  
  return (
    <Stack
      sx={{
        position: "relative",
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          right: 0,
          top: 0,
          zIndex: 1000000,
        }}
        onClick={handlePreview}
      >
        {previewing ? <EditIcon /> : <PreviewIcon />}
      </IconButton>
      {renderContent()}
    </Stack>
  );
}
